module.exports = __webpack_public_path__ + "static/farnoosh_mobile-48af166627c7ded420c21f946315cdc6.png";